"use client";

import { useState } from "react";
import arrowDownIcon from "@/assets/images/arrow_down.svg";

export default function HBetMatchLeagues({ league, matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="rounded-[8px] overflow-hidden border border-solid border-[var(--theme-border)] mb-0">
      {/* League Header */}
      <div className="relative flex items-center bg-[var(--theme-border)] px-[16px] md:px-2 py-1 border-b border-solid border-[var(--theme-border)] md:pr-10">
        {/* League name */}
        <div className="text-[16px] font-bold text-[var(--theme-text-muted)] flex-1 leading-tight">
          {league?.nameVN || league?.name || "Giải đấu"}
        </div>

        <div className="hidden md:grid ml-auto grid-cols-[18px_140px_140px_140px] gap-x-2 w-fit items-center">
          <div className="w-[18px] shrink-0" />
          <div className="text-[14px] text-center text-[var(--theme-text-muted)]">Kèo chấp</div>
          <div className="text-[14px] text-center text-[var(--theme-text-muted)]">Tài/Xỉu</div>
          <div className="text-[14px] text-center text-[var(--theme-text-muted)]">1X2</div>
        </div>

        <div
          className="ml-auto md:ml-0 md:absolute md:right-2 md:top-1/2 md:-translate-y-1/2 cursor-pointer"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          <img src={arrowDownIcon} className={`h-[16px] w-[16px] brightness-0 invert transition-transform duration-200 ${isExpanded ? "" : "rotate-180"}`} alt="" />
        </div>
      </div>

      {/* Match List */}
      {isExpanded ? (
        <div className="bg-[var(--theme-bg)]">
          {matches.map((match, idx) => (
            <div key={match?.id || idx}>
              {render(match, idx)}
              {idx < matches.length - 1 ? (
                <hr className="bg-[var(--theme-border)] mx-auto h-[1px] w-[90%] items-center border-none hidden md:block md:w-full m-0" />
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
